import { useEffect, useState } from "react";
import { BellRing } from "lucide-react";
import { fetchAdminWaits, fmtDate } from "@/lib/bf";

export default function BFWaits() {
  const [rows, setRows] = useState(null);
  useEffect(() => { fetchAdminWaits().then(setRows).catch(() => setRows([])); }, []);
  if (!rows) return null;
  return (
    <section className="invite-box bfa-waits" data-testid="bfa-waits">
      <h3><BellRing size={16} /> Saloane care așteaptă produse fără stoc</h3>
      <p className="st-hint">Bifează „Fără stoc” la un produs ca să apară gri, cu butonul „Anunță-mă când revine”. Când îl debifezi și apeși Salvează, saloanele de aici și agenții lor primesc e-mail.</p>
      {!rows.length && <p className="st-hint" data-testid="bfa-waits-empty">Niciun salon nu a cerut încă anunț.</p>}
      <ul>
        {rows.map((r) => (
          <li key={r.pid} data-testid={`bfa-wait-${r.pid}`}>
            <div className="bfa-wait-head">
              <b>{r.name}</b>
              <small>{r.code ? `Cod ${r.code} · ` : ""}{r.out ? "fără stoc" : "în stoc"} · {r.salons.length} {r.salons.length === 1 ? "salon" : "saloane"}</small>
            </div>
            <div className="bfa-wait-salons">
              {r.salons.map((s, i) => <span key={i} className={s.sent_at ? "is-sent" : ""}>{s.salon || "Salon"}{s.phone ? ` · ${s.phone}` : ""}{s.sent_at ? ` · anunțat ${fmtDate(s.sent_at.slice(0, 10))}` : ""}</span>)}
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
